var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGpslogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "111px",
    height: "110px",
    viewBox: "0 0 111 110",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-greypath") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-lg-1024-.container-lg",
    transform: "translate(-494, -4376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AboutCollaborate",
    transform: "translate(-205, 2687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-greypath",
    transform: "translate(699.5, 1689)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-17",
    fill: "#57534E",
    cx: 55,
    cy: 55,
    r: 55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1265914,78 L52.9372701,78 C45.2977954,78 40.4054449,73.1804064 40.4054449,66.1847201 L40.4054449,43.8130752 C40.4054449,36.8923505 45.2977954,32 52.9372701,32 L56.4053491,32 C60.2901267,32 62.9799273,33.1354486 64.9024733,34.7691718 C66.0996551,35.7502876 66.9484856,36.9606979 67.6606213,38.2328413 C67.8678682,38.6561541 67.7267639,39.0089149 67.3056558,39.2205713 L63.5531635,41.0659509 C63.1959932,41.2754026 62.9137847,41.1320936 62.6999235,40.7793328 C61.2139189,38.2328413 58.7335699,36.8923505 56.4053491,36.8923505 L52.9372701,36.8923505 C49.1142256,36.8923505 45.9989074,39.9282975 45.9989074,43.8130752 L45.9989074,66.1847201 C45.9989074,69.9350077 49.0414687,73.1142638 52.9372701,73.1142638 L55.1265914,73.1142638 C58.8746742,73.1142638 62.0693636,70.0077646 62.0693636,66.1847201 L62.0693636,61.0123658 C62.0693636,60.5229103 61.8488882,60.3046396 61.3528184,60.3046396 L59.5449196,60.3046396 C59.0444403,60.3046396 58.8305791,60.0929831 58.8305791,59.6035276 L58.8305791,56.1332439 C58.8305791,55.6415836 59.0444403,55.4255176 59.5449196,55.4255176 L66.9484856,55.4255176 C67.4379411,55.4255176 67.6606213,55.6415836 67.6606213,56.1332439 L67.6606213,66.1847201 C67.6606213,73.1142638 62.7638613,78 55.1265914,78",
    id: "Fill-1",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpslogo);
export default __webpack_public_path__ + "static/media/GPSLOGO.8968c3d9d9197fd90f90e659806f0a15.svg";
export { ForwardRef as ReactComponent };